var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.542 21.75H11.042M15.542 30.75H11.042M29.042 12.75H11.042M38.042 12.3V35.7C38.042 39.4804 38.042 41.3705 37.3063 42.8144C36.6591 44.0845 35.6265 45.1171 34.3564 45.7643C32.9125 46.5 31.0223 46.5 27.242 46.5H12.842C9.06164 46.5 7.17146 46.5 5.72756 45.7643C4.45746 45.1171 3.42484 44.0845 2.7777 42.8144C2.04199 41.3705 2.04199 39.4804 2.04199 35.7V12.3C2.04199 8.51965 2.04199 6.62947 2.7777 5.18556C3.42484 3.91547 4.45746 2.88285 5.72756 2.23571C7.17146 1.5 9.06164 1.5 12.842 1.5H27.242C31.0223 1.5 32.9125 1.5 34.3564 2.23571C35.6265 2.88285 36.6591 3.91547 37.3063 5.18556C38.042 6.62947 38.042 8.51965 38.042 12.3Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.d3a738bc845ea72b0aaa0fbf8aca99db.svg";
export { ForwardRef as ReactComponent };